<p-scrollPanel class="w-100" [style]="{height: '60vh'}">
  <waitLoading *ngIf="showWait"></waitLoading>
  <div>
    <img src="assets/img/icon-login.svg" class="float-left" />
    <div class="container-fluid">
      <div class="row ml-5">
        <div class="col-12">
          <label>{{ 'General.user' | translate }}</label>
          <div>
            <input pInput id="userName" name="userName" type="text" [(ngModel)]="data.userId" autofocus
              autocapitalize="off" tabindex="1" class="w-100" />
          </div>
        </div>
        <div class="col-12">
          <label>{{ 'LoginView.pass' | translate }}</label>
          <div>
            <input pInput id="pass" name="pass" [(ngModel)]="data.password" autocomplete="off" type="password"
              tabindex="2" class="w-100" />
          </div>
        </div>
        <div class="col-12 text-center m-t-sm">
          <button pButton tabindex="3" class="btn btn-primary btn-lg" (click)="accept()"
            [attr.disabled]="(!data?.userId || !data?.password)?'disabled':undefined">
            {{ 'General.accept' | translate }} </button>
          <button pButton tabindex="4" class="btn btn-secondary btn-lg m-l-sm" (click)="close()">
            {{ 'General.cancel' | translate }} </button>
        </div>
      </div>
    </div>
    <div class="row m-t-md m-b-xl">
      <div class="col-12 text-center alert alert-danger" *ngIf="errorMsg">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        <span class="m-l-sm" [innerHTML]="errorMsg"></span>
      </div>
    </div>
  </div>

</p-scrollPanel>